
export const getJson = (url) => {
    return new Promise((resolve, reject) => {
        fetch(url, {
            headers: {
                'Dreame-RLC': 'd12671138cc6a559a275fea77a5a2383a68291663dbf8cad-1'
            }
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
            resolve(json);
        })
    });
}


export const postJson = (url, data) => {
    var fetchOptions = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            'Tenant-Id': '000002',
            'Dreame-RLC': 'd12671138cc6a559a275fea77a5a2383a68291663dbf8cad-1'
        },
        body: JSON.stringify(data)
    };
    return new Promise((resolve, reject) => {
        fetch(url, fetchOptions).then((response) => response.json()).then((data) => {
            resolve(data);
        })
    })
}